require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-german-brigante-bridge-hotel.json") })
        }
      }, "path---interview-german-brigante-bridge-hotel");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-german-brigante-bridge-hotel!./.cache/json/interview-german-brigante-bridge-hotel.json
// module id = 675
// module chunks = 231608221292675